import styles from '../PrizeDetails.styles.css';

export interface IPrizeDetailsClassNames {
    title: string;
    prizeDetailsCollapse: string;
    prizeDetailsListContainer: string;
    prizeDetailsContainer: string;
}

export interface IPrizeDetailsPresenterConfig {}

export class PrizeDetailsPresenter {
    public getAllClassNames (): IPrizeDetailsClassNames {
        return {
            title: styles.title,
            prizeDetailsCollapse: styles.prizeDetailsCollapse,
            prizeDetailsListContainer: styles.prizeDetailsListContainer,
            prizeDetailsContainer: styles.prizeDetailsContainer,
        };
    }
}
